import React from "react";

import brFlag from "../../../../img/landing-page/br-flag.png";
import mailIcon from "../../../../img/landing-page/mail-icon.png";
import mmLogoWhite from "../../../../img/mm-logo-branca.png";
import ra1000 from "../../../../img/certifies/ra-1000.png";
import armouredSite from "../../../../img/certifies/site-blindado.png";

const LandingPageLayoutFooter = () => {
	return (
		<div className="offers-landing-page-footer">
			<div className="col-xs-16 offers-landing-page-footer__brand-media">
				<div className="container">
					<img
						alt=""
						src={mmLogoWhite}
						className="offers-landing-page-footer__brand-media--brand-logo"
					/>
					<div className="offers-landing-page-footer__brand-media--contact">
						<a href="http://www.maxmilhas.com.br" title="MaxMilhas">
							<img src={brFlag} alt="" />
							www.maxmilhas.com.br
						</a>
						<br />
						<a href="mailto:contato@maxmilhas.com.br" title="Email contato MaxMilhas">
							<img src={mailIcon} alt="" />
							contato@maxmilhas.com.br
						</a>
					</div>
					<div className="offers-landing-page-footer__brand-media--social">
						<p>Siga a MaxMilhas:</p>
						<span>
							+ 600 mil
							<br /> likes
						</span>
						<a target="_bland" href="https://www.facebook.com/MaxMilhas" title="Facebook">
							<i className="icon-facebook" />
						</a>
						<a target="_bland" href="https://twitter.com/maxmilhas" title="Facebook">
							<i className="icon-twitter" />
						</a>
						<a target="_bland" href="https://www.instagram.com/maxmilhas/" title="Facebook">
							<i className="icon-instagram" />
						</a>
						<a target="_bland" href="https://www.linkedin.com/company/max-milhas/" title="Facebook">
							<i className="icon-linkedin" />
						</a>
						<a target="_bland" href="https://www.youtube.com/user/canalmaxmilhas" title="Facebook">
							<i className="icon-youtube" />
						</a>
					</div>
				</div>
			</div>
			<div className="col-xs-16 offers-landing-page-footer__certifies">
				<div className="container">
					<div className="offers-landing-page-footer__certifies__content">
						<h5>Certificados</h5>

						<div>
							<img src={armouredSite} alt="" />
							<img src={ra1000} alt="" />
						</div>

						<hr />
					</div>
				</div>
			</div>
		</div>
	);
};

export default LandingPageLayoutFooter;
